Object.defineProperty(String.prototype, "capitalize", {
	value: function () {
		const temp = this.toLowerCase()

		return temp.charAt(0).toUpperCase() + temp.slice(1)
	},
	enumerable: false
})
